/* LIBERTY hat page: bundle picker (1-4 hats, mix and match designs/colours), gallery, buy now. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };

  $$('[data-lb-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) { var t = $(a.getAttribute('href')); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); } });
  });

  function showPhoto(id) {
    if (!id) return;
    var fig = $('.lb-gal__fig[data-media="' + id + '"]'); if (!fig) return;
    $$('.lb-gal__fig').forEach(function (f) { f.classList.toggle('is-on', f === fig); });
    $$('.lb-gal__t').forEach(function (t) { t.classList.toggle('is-on', t.dataset.thumb === String(id)); });
  }
  $$('.lb-gal__t').forEach(function (t) { t.addEventListener('click', function () { showPhoto(t.dataset.thumb); }); });


  // top bar messages take turns
  $$('[data-lb-bar]').forEach(function (bar) {
    var ms = $$('.lb-bar__m', bar), i = 0;
    if (ms.length < 2 || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    setInterval(function () { ms[i].classList.remove('is-on'); i = (i + 1) % ms.length; ms[i].classList.add('is-on'); }, 3500);
  });

  // rotating quotes
  $$('[data-lb-quotes]').forEach(function (box) {
    var qs = $$('.lb-quotes__q', box), i = 0;
    if (qs.length < 2 || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    setInterval(function () { qs[i].classList.remove('is-on'); i = (i + 1) % qs.length; qs[i].classList.add('is-on'); }, 6000);
  });


  // star line under the title: average of real, named reviews on this page
  (function () {
    var rate = $('#lbRate'), proof = $('#lbProof'); if (!rate || !proof || !rate.hasAttribute('data-auto')) return;
    var rs = $$('[data-count]').map(function (a) { return +a.dataset.count; });
    if (!rs.length) return;
    var avg = rs.reduce(function (x, y) { return x + y; }, 0) / rs.length;
    $('#lbAvg').textContent = avg.toFixed(1);
    $('#lbCnt').textContent = rs.length + ' review' + (rs.length > 1 ? 's' : '');
    rate.style.setProperty('--lb-fill', (avg / 5 * 100) + '%');
    rate.hidden = false; proof.hidden = false;
  })();

  // order-by countdown (days left until the gift deadline, end of that day)
  $$('[data-lb-deadline]').forEach(function (el) {
    var p = el.dataset.lbDeadline.split('-'), end = new Date(+p[0], +p[1] - 1, +p[2], 23, 59, 59);
    var days = Math.ceil((end - new Date()) / 86400000), out = $('[data-lb-days]', el);
    if (isNaN(days) || days < 1) { el.hidden = true; return; }
    if (out) out.textContent = days === 1 ? ' · last day' : ' · ' + days + ' days left';
  });

  var dataEl = $('#lbData'), form = $('#lbForm');
  if (!dataEl || !form) return;
  var d = JSON.parse(dataEl.textContent), opts = d.options, slotsEl = $('#lbSlots'), totalEl = $('#lbTotal'), note = $('#lbNote');
  var byId = {}; opts.forEach(function (o) { byId[o.id] = o; });
  var firstOk = (byId[d.start] && byId[d.start].ok) ? d.start : ((opts.filter(function (o) { return o.ok; })[0] || {}).id);
  var picks = [];

  function count() { var r = $('input[name="lb-n"]:checked', form); return r ? +r.value : 1; }

  function render() {
    var n = count();
    while (picks.length < n) picks.push(picks.length ? picks[picks.length - 1] : firstOk);
    slotsEl.innerHTML = '';
    if (form.dataset.pick === 'false') { picks = []; for (var k = 0; k < n; k++) picks.push(firstOk); }
    for (var i = 0; i < n && form.dataset.pick !== 'false'; i++) {
      var row = document.createElement('label'); row.className = 'lb-slot';
      var lab = document.createElement('span'); lab.className = 'lb-slot__n'; lab.textContent = 'Hat ' + (i + 1);
      var sel = document.createElement('select'); sel.dataset.i = i; sel.setAttribute('aria-label', 'Hat ' + (i + 1) + ' design and colour');
      opts.forEach(function (o) {
        var op = document.createElement('option'); op.value = o.id; op.textContent = o.label + (o.ok ? '' : ' (sold out)'); op.disabled = !o.ok;
        if (String(o.id) === String(picks[i])) op.selected = true;
        sel.appendChild(op);
      });
      row.appendChild(lab); row.appendChild(sel); slotsEl.appendChild(row);
    }
    var price = d.prices[String(n)];
    totalEl.textContent = price ? money(price) : '';
    var pick = $('#lbStickyPick'), on = $('input[name="lb-n"]:checked', form), nm = on && $('.lb-tier__name', on.parentNode);
    if (pick) pick.textContent = (nm ? nm.textContent + ' · ' : '') + (price ? money(price) : '');
  }

  // sticky buy bar once the main button has scrolled out of view
  var sticky = $('#lbSticky'), buyBtn = $('#lbBuy');
  if (sticky && buyBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var e = es[0]; sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }).observe(buyBtn);
  }

  slotsEl.addEventListener('change', function (e) {
    var sel = e.target; if (sel.tagName !== 'SELECT') return;
    picks[+sel.dataset.i] = +sel.value;
    var o = byId[sel.value]; if (o && o.own && o.media) showPhoto(o.media);
  });
  $$('input[name="lb-n"]', form).forEach(function (r) { r.addEventListener('change', render); });
  if (!$('input[name="lb-n"]:checked', form)) { var r0 = $('input[name="lb-n"]', form); if (r0) r0.checked = true; }

  function say(t) { note.textContent = t; }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var n = count(), qty = {};
    for (var i = 0; i < n; i++) { var id = picks[i]; if (!id) { say('Please choose a colour for every hat.'); return; } qty[id] = (qty[id] || 0) + 1; }
    var items = Object.keys(qty).map(function (id) { return { id: +id, quantity: qty[id] }; });
    var btn = $('#lbBuy'); btn.setAttribute('aria-busy', 'true'); say('');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.'); return j; }); })
      .then(function () { location.href = '/checkout'; })
      .catch(function (er) { btn.removeAttribute('aria-busy'); say(er.message); });
  });

  render();
  var o0 = byId[picks[0]]; if (o0 && o0.own && o0.media) showPhoto(o0.media);
})();
